// Shared layout for the Terms and Privacy pages: dark hero, sticky contents list and one card per section.
import { PageHero } from "./ui";
import "../../css/Legal.css";

const slug = title => title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export default function LegalLayout({ title, highlight, lead, crumbs, sections }) {
  return (
    <>
      <PageHero
        crumbs={crumbs}
        eyebrow="Legal"
        title={
          <>
            {title} <span>{highlight}</span>
          </>
        }
        lead={lead}
      />
      <section className="ft-section">
        <div className="ft-container legal">
          <nav className="legal__toc" aria-label="On this page">
            <p className="legal__toc-title">On this page</p>
            <ol>
              {sections.map(s => (
                <li key={s.title}>
                  <a href={`#${slug(s.title)}`}>{s.title.replace(/^\d+\.\s*/, "")}</a>
                </li>
              ))}
            </ol>
          </nav>
          <div className="legal__body">
            {sections.map(s => (
              <article className="legal__section" id={slug(s.title)} key={s.title}>
                <h2>{s.title}</h2>
                <ul>
                  {s.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
